import Vue from 'vue'
import Router from 'vue-router'
import Results from '@/views/Results.vue'

Vue.use(Router)

let route = {
  path: global.vesteda.baseUrl,
  name: 'home',
}

if (document.querySelector('#unit-result-list')) {
  route.component = Results
}

export default new Router({
  mode: 'history',
  routes: [route],
})
